module.exports = __webpack_public_path__ + "img/walking.2e608871.gif";